export default {
  // General
  'app.name': 'Soulidari',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.search': 'Buscar',
  'common.loading': 'Cargando...',
  'common.success': '¡Éxito!',
  'common.error': 'Error',
  'common.close': 'Cerrar',
  'common.confirm': 'Confirmar',
  'common.back': 'Volver',
  'common.next': 'Siguiente',
  'common.yes': 'Sí',
  'common.no': 'No',
  
  // Profile
 'layout.masterDashboard': 'Panel Master',
'layout.companies': 'Empresas',
'layout.allCompanies': 'Todas las Empresas',
'layout.system': 'Sistema',
'layout.systemUsers': 'Usuarios del Sistema',
'layout.auditLogs': 'Registros de Auditoría',
'layout.dashboard': 'Panel de Control',
'layout.myDashboard': 'Mi Panel',
'layout.attendance': 'Atención',
'layout.conversations': 'Conversaciones',
'layout.myConversations': 'Mis Conversaciones',
'layout.contacts': 'Contactos',
'layout.tasks': 'Tareas',
'layout.myTasks': 'Mis Tareas',
'layout.chatbot': 'Chatbot',
'layout.visualFunnel': 'Embudo Visual',
'layout.crm': 'CRM',
'layout.leads': 'Leads',
'layout.monitoring': 'Monitoreo',
'layout.teamPerformance': 'Rendimiento del Equipo',
'layout.appointments': 'Citas',
'layout.biIntegration': 'Integración BI',
'layout.achievements': 'Logros',
'layout.myPerformance': 'Mi Rendimiento',
'layout.administration': 'Administración',
'layout.users': 'Usuarios',
'layout.sectors': 'Sectores',
'layout.phoneNumbers': 'Números WhatsApp',
'layout.communication': 'Comunicación',
'layout.templates': 'Plantillas',
'layout.bulkMessaging': 'Envíos Masivos',
'layout.automations': 'Automatizaciones',
'layout.aiAgents': 'Agentes IA',
'layout.optIn': 'Gestión de Opt-in',
'layout.reports': 'Informes',
'layout.businessAccounts': 'Cuentas Business',
'layout.profile': 'Mi Perfil',
'layout.settings': 'Configuración',
'layout.logout': 'Salir',
'layout.fullControl': 'Control total del sistema',
'layout.status': 'Estado',
'layout.online': 'En línea',
'layout.accessRestricted': 'Acceso Restringido',
'layout.featureNotAvailable': 'Funcionalidad no disponible en su plan',
'layout.currentPlan': 'Plan actual',
'layout.upgradeToUnlock': 'Esta funcionalidad está disponible en planes superiores.',
'layout.contactSupport': 'Contacte con soporte para actualizar su plan y desbloquear esta funcionalidad.',
'layout.viewPlans': 'Ver Planes',
  
// Dashboard
'dashboard.helloOperator': 'Hola, {name}',
'dashboard.operator': 'Operador',
'dashboard.welcome': 'Bienvenido al Panel',
'dashboard.operatorSubtitle': 'Seguimiento de su rendimiento',
'dashboard.subtitle': 'Seguimiento del rendimiento de su empresa en tiempo real.',
'dashboard.viewReports': 'Ver Informes',
'dashboard.newCampaign': 'Nueva Campaña',
'dashboard.errorLoading': 'Error al cargar datos',
'dashboard.tryAgain': 'Intentar de Nuevo',
'dashboard.yourStats': 'Sus Estadísticas',
'dashboard.keepGoodWork': '¡Siga con el excelente trabajo!',
'dashboard.total': 'Total',
'dashboard.resolved': 'Resueltas',
'dashboard.avgTime': 'Tiempo Prom.',
'dashboard.totalConversations': 'Total de Conversaciones',
'dashboard.activeNow': 'activas ahora',
'dashboard.totalMessages': 'Total de Mensajes',
'dashboard.today': 'hoy',
'dashboard.activeConversations': 'Conversaciones Activas',
'dashboard.inProgress': 'En progreso ahora',
'dashboard.avgResponseTime': 'Tiempo Medio de Respuesta',
'dashboard.conversationsToday': 'conversaciones hoy',
'dashboard.advancedReports': 'Informes Avanzados',
'dashboard.detailedMetrics': 'Métricas detalladas de rendimiento',
'dashboard.viewReportsArrow': 'Ver Informes →',
'dashboard.leadsCRM': 'CRM de Leads',
'dashboard.manageLeads': 'Gestione sus leads y oportunidades',
'dashboard.manageLeadsArrow': 'Gestionar Leads →',
'dashboard.automations': 'Automatizaciones',
'dashboard.configureAuto': 'Configure respuestas automáticas',
'dashboard.configureArrow': 'Configurar →',
'dashboard.recentConversations': 'Conversaciones Recientes',
'dashboard.viewAll': 'Ver todas',
'dashboard.contact': 'Contacto',
'dashboard.lastMessage': 'Último Mensaje',
'dashboard.dateTime': 'Fecha/Hora',
'dashboard.status': 'Estado',
'dashboard.actions': 'Acciones',
'dashboard.loadingConversations': 'Cargando conversaciones...',
'dashboard.noConversations': 'No se encontraron conversaciones.',
'dashboard.user': 'Usuario',
'dashboard.noMessages': 'Sin mensajes',
'dashboard.statusActive': 'Activa',
'dashboard.statusClosed': 'Cerrada',
'dashboard.statusPending': 'Pendiente',
'dashboard.openChat': 'Abrir Chat',
  
 // Conversations
'contacts.title': 'Contactos',
'contacts.subtitle': 'Administra tu base de contactos',
'contacts.total': 'Total',
'contacts.searchPlaceholder': 'Buscar por nombre o teléfono...',
'contacts.all': 'Todos',
'contacts.optInOnly': 'Solo Opt-in',
'contacts.optOutOnly': 'Solo Opt-out',
'contacts.selectAtLeastOne': 'Selecciona al menos un contacto',
'contacts.name': 'Nombre',
'contacts.notInformed': 'No informado',
'contacts.phone': 'Teléfono',
'contacts.createdIn': 'Creado en',
'contacts.selectedContacts': '{count} contacto(s) seleccionado(s)',
'contacts.clear': 'Limpiar',
'contacts.sendToBulk': 'Enviar a Envío Masivo',
'contacts.contact': 'Contacto',
'contacts.createdAt': 'Creado',
'contacts.actions': 'Acciones',
'contacts.loadingContacts': 'Cargando contactos...',
'contacts.noResults': 'No se encontraron contactos',
'contacts.tryAdjustFilters': 'Intenta ajustar los filtros',
'contacts.contactsWillAppear': 'Los contactos aparecerán aquí',
'contacts.noName': 'Sin nombre',
'contacts.viewDetails': 'Ver detalles',
'contacts.sendToCampaign': 'Enviar a campaña',
'contacts.showing': 'Mostrando',
'contacts.of': 'de',
'contacts.contacts': 'contactos',
'contacts.selectedCount': '{count} seleccionado(s)',


// Leads
'leads.title': 'CRM de Leads',
'leads.subtitle': 'Administra tus leads y sigue el embudo de ventas',
'leads.newLead': 'Nuevo Lead',
'leads.total': 'Total',
'leads.statusNew': 'Nuevo',
'leads.statusContacted': 'Contactado',
'leads.statusQualified': 'Calificado',
'leads.statusConverted': 'Convertido',
'leads.statusLost': 'Perdido',
'leads.sourceManual': 'Manual',
'leads.sourceWebsite': 'Sitio Web',
'leads.sourceCampaign': 'Campaña',
'leads.searchPlaceholder': 'Buscar por nombre, teléfono o email...',
'leads.allStatuses': 'Todos los estados',
'leads.filter': 'Filtrar',
'leads.name': 'Nombre',
'leads.contact': 'Contacto',
'leads.status': 'Estado',
'leads.source': 'Origen',
'leads.responsible': 'Responsable',
'leads.sector': 'Sector',
'leads.actions': 'Acciones',
'leads.noResults': 'No se encontraron leads.',
'leads.confirmDelete': '¿Está seguro de eliminar este lead?',
'leads.errorDelete': 'Error al eliminar',
'leads.editLead': 'Editar Lead',
'leads.phone': 'Teléfono',
'leads.email': 'Email',
'leads.noResponsible': 'Sin responsable',
'leads.noSector': 'Sin sector',
'leads.lostReason': 'Motivo de la pérdida',

// Team Performance
'teamPerformance.title': 'Rendimiento del Equipo',
'teamPerformance.subtitle': 'Seguimiento del rendimiento de todos los atendentes',
'teamPerformance.last7days': 'Últimos 7 días',
'teamPerformance.last30days': 'Últimos 30 días',
'teamPerformance.last90days': 'Últimos 90 días',
'teamPerformance.activeAttendants': 'Atendentes activos',
'teamPerformance.totalConversations': 'Total de conversaciones',
'teamPerformance.appointments': 'Citas',
'teamPerformance.avgResponseTime': 'Tiempo medio respuesta',
'teamPerformance.ranking': 'Ranking de Atendentes',
'teamPerformance.position': 'Posición',
'teamPerformance.attendant': 'Atendente',
'teamPerformance.conversations': 'Conversaciones',
'teamPerformance.responseTime': 'Tiempo Resp.',
'teamPerformance.conversion': 'Conversión',
'teamPerformance.satisfaction': 'Satisfacción',
'teamPerformance.noData': 'No hay datos disponibles',
'teamPerformance.min': 'min',
'teamPerformance.conv': 'conv.',
'teamPerformance.conversionByType': 'Conversión por Tipo de Conversación',
'teamPerformance.conversionRate': 'Tasa de Conversión',

// Appointments
'appointments.title': 'Citas',
'appointments.subtitle': 'Administra las consultas y atenciones',
'appointments.professionals': 'Profesionales',
'appointments.registerProfessionals': 'Registrar Profesionales',
'appointments.statistics': 'Estadísticas',
'appointments.sendReminders': 'Enviar Recordatorios',
'appointments.newAppointment': 'Nueva Cita',
'appointments.noSpecialty': 'Sin especialidad',
'appointments.professional': 'PROFESIONAL',
'appointments.allProfessionals': 'TODOS LOS PROFESIONALES',
'appointments.fullSchedule': 'Agenda Completa',
'appointments.appointmentsLower': 'citas',
'appointments.confirmedLower': 'confirmadas',
'appointments.noShows': 'no asistieron',
'appointments.searchPatient': 'Buscar paciente...',
'appointments.all': 'Todos',
'appointments.scheduled': 'Programado',
'appointments.confirmed': 'Confirmado',
'appointments.completed': 'Completado',
'appointments.noShow': 'No asistió',
'appointments.cancelled': 'Cancelado',
'appointments.time': 'Horario',
'appointments.patient': 'Paciente',
'appointments.contact': 'Contacto',
'appointments.type': 'Tipo',
'appointments.observation': 'Observación',
'appointments.status': 'Estado',
'appointments.actions': 'Acciones',
'appointments.select': 'Seleccione',
'appointments.fullName': 'Nombre completo',
'appointments.typeConsultation': 'Consulta',
'appointments.typeReturn': 'Retorno',
'appointments.typeExam': 'Examen',
'appointments.typeProcedure': 'Procedimiento',
'appointments.typeUrgency': 'Urgencia',
'appointments.observationPlaceholder': 'Ej: Traer exámenes anteriores...',
'appointments.schedule': 'Programar',
'appointments.sendReminder': 'Enviar Recordatorio',
'appointments.messageToBeSent': 'Mensaje que se enviará',
'appointments.reminderMessage': '¡Hola {name}! 👋\nLe recordamos que tiene una cita programada para el {date} a las {time}.\nPor favor confirme su presencia respondiendo este mensaje. ¡Hasta pronto! 😊',
'appointments.sendVia': 'Enviar por',
'appointments.scheduleStatistics': 'Estadísticas de la Agenda',
'appointments.total': 'Total',
'appointments.attendanceRate': 'Tasa de Asistencia',
'appointments.statusDistribution': 'Distribución de Estado',
// Appointments - Mensajes adicionales
'appointments.errorLoading': 'Error al cargar las citas',
'appointments.statusUpdated': 'Estado actualizado a',
'appointments.errorUpdateStatus': 'Error al actualizar el estado',
'appointments.observationSaved': '¡Observación guardada!',
'appointments.errorSaveObs': 'Error al guardar la observación',
'appointments.fillRequiredFields': 'Complete los campos obligatorios',
'appointments.createdSuccess': '¡Cita creada con éxito!',
'appointments.errorCreate': 'Error al crear la cita',
'appointments.confirmDelete': '¿Eliminar esta cita?',
'appointments.deletedSuccess': 'Cita eliminada',
'appointments.errorDelete': 'Error al eliminar la cita',
'appointments.reminderSent': 'Recordatorio enviado a',
'appointments.errorSendReminder': 'Error al enviar el recordatorio',
'appointments.noPending': 'No hay citas pendientes',
'appointments.confirmSendReminders': 'Enviar recordatorio a',
'appointments.remindersSent': 'Recordatorios enviados a',
'appointments.patients': 'pacientes',

// BI Integration
'biIntegration.title': 'Integración con BI',
'biIntegration.subtitle': 'Conecte sus datos a Power BI o Google Data Studio',
'biIntegration.newIntegration': 'Nueva Integración',
'biIntegration.powerBiDescription': 'Conéctese a Power BI vía webhook para actualizaciones en tiempo real',
'biIntegration.dataStudioDescription': 'Exporte datos en CSV para conectar a Google Data Studio',
'biIntegration.activeConfig': 'Configuración activa',
'biIntegration.format': 'Formato',
'biIntegration.autoExport': 'Auto-exportar',
'biIntegration.frequency': 'Frecuencia',
'biIntegration.lastExport': 'Última exportación',
'biIntegration.exportNow': 'Exportar Ahora',
'biIntegration.exporting': 'Exportando...',
'biIntegration.notConfigured': 'No configurado',
'biIntegration.configure': 'Configurar',
'biIntegration.viewDocs': 'Ver documentación',
'biIntegration.configureConnection': 'Configure la conexión con su herramienta de BI',
'biIntegration.biTool': 'Herramienta de BI',
'biIntegration.webhookUrl': 'Webhook URL (Power BI)',
'biIntegration.apiKey': 'API Key (opcional)',
'biIntegration.authKey': 'Clave de autenticación',
'biIntegration.exportFormat': 'Formato de Exportación',
'biIntegration.exportFrequency': 'Frecuencia de Exportación',
'biIntegration.freq_hourly': 'Cada hora',
'biIntegration.freq_daily': 'Diariamente',
'biIntegration.freq_weekly': 'Semanalmente',
'biIntegration.configCreated': '¡Configuración creada con éxito!',
'biIntegration.errorCreate': 'Error al crear configuración',
'biIntegration.dataExported': 'Datos exportados a',
'biIntegration.errorExport': 'Error al exportar',

// Achievements
'achievements.title': 'Logros y Gamificación',
'achievements.subtitle': '¡Desbloquea medallas y sube en el ranking!',
'achievements.medalsWon': 'Medallas ganadas',
'achievements.totalPoints': 'Puntos totales',
'achievements.rankingPosition': 'Posición en el ranking',
'achievements.topMonth': 'Top 10 del Mes',
'achievements.you': 'tú',
'achievements.achievementsLower': 'logros',
'achievements.points': 'puntos',
'achievements.pts': 'pts',
'achievements.won': 'Ganado',
'achievements.locked': 'Bloqueado',
'achievements.categorySpeed': 'Velocidad',
'achievements.categoryVolume': 'Volumen',
'achievements.categoryQuality': 'Calidad',
'achievements.categoryConversion': 'Conversión',

// Users
'users.title': 'Gestión de Usuarios',
'users.subtitle': 'Administre perfiles, permisos y accesos del equipo.',
'users.newUser': 'Nuevo Usuario',
'users.limitReached': 'Límite Alcanzado',
'users.total': 'Total',
'users.active': 'Activos',
'users.inactive': 'Inactivos',
'users.planUsage': 'Uso del Plan',
'users.plan': 'Plan',
'users.userLimitReached': 'Límite de Usuarios Alcanzado',
'users.allowsMax': 'permite máximo',
'users.usersLower': 'usuarios',
'users.contactSupportUpgrade': 'Para agregar más usuarios, contacte al soporte o actualice su plan.',
'users.searchPlaceholder': 'Buscar por nombre o email...',
'users.allProfiles': 'Todos los perfiles',
'users.roleAdmin': 'Administrador',
'users.roleManager': 'Gerente',
'users.roleAttendant': 'Atendente',
'users.allStatuses': 'Todos los estados',
'users.user': 'Usuario',
'users.email': 'Email',
'users.profile': 'Perfil',
'users.sector': 'Sector',
'users.status': 'Estado',
'users.actions': 'Acciones',
'users.editUser': 'Editar Usuario',
'users.limitReachedModal': '¡Límite alcanzado! No se pueden crear nuevos usuarios.',
'users.userPhoto': 'Foto del Usuario',
'users.fullName': 'Nombre completo',
'users.fullNamePlaceholder': 'Ej: Juan Pérez',
'users.emailPlaceholder': 'ejemplo@email.com',
'users.newPasswordKeep': 'Nueva contraseña (deje vacío para mantener)',
'users.password': 'Contraseña',
'users.passwordMinChars': 'Mínimo 6 caracteres',
'users.noSectorLinked': 'Sin sector vinculado',
'users.saveChanges': 'Guardar Cambios',
'users.createUser': 'Crear Usuario',

// Tasks
'tasks.title': 'Tareas y Seguimiento',
'tasks.subtitle': 'Administra tus tareas y seguimiento de plazos',
'tasks.newTask': 'Nueva Tarea',
'tasks.priorityLow': 'Baja',
'tasks.priorityNormal': 'Normal',
'tasks.priorityHigh': 'Alta',
'tasks.priorityUrgent': 'Urgente',
'tasks.errorUpdateStatus': 'Error al actualizar estado',
'tasks.confirmDelete': '¿Eliminar tarea?',
'tasks.errorDelete': 'Error al eliminar',
'tasks.overdueCount': '{count} tarea(s) atrasada(s)',
'tasks.dueOn': 'Venció el',
'tasks.complete': 'Completar',
'tasks.allTasks': 'Todas las Tareas',
'tasks.lead': 'Lead',
'tasks.responsible': 'Resp',
'tasks.noTasks': 'No se encontraron tareas.',
'tasks.editTask': 'Editar Tarea',
'tasks.titleField': 'Título',
'tasks.description': 'Descripción',
'tasks.noLinkedLead': 'Sin lead vinculado',
'tasks.noResponsible': 'Sin responsable',

// Chatbots
'chatbots.title': 'Chatbot',
'chatbots.subtitle': 'Automatiza la primera atención con menú de opciones',
'chatbots.newChatbot': 'Nuevo Chatbot',
'chatbots.updated': '¡Chatbot actualizado!',
'chatbots.created': '¡Chatbot creado!',
'chatbots.errorUpdate': 'Error al actualizar',
'chatbots.confirmDelete': '¿Eliminar este chatbot?',
'chatbots.errorDelete': 'Error al eliminar',
'chatbots.fillAllOptionFields': 'Completa todos los campos de la opción',
'chatbots.sectorNotFound': 'Sector no encontrado',
'chatbots.totalSessions': 'Total de Sesiones',
'chatbots.completed': 'Completados',
'chatbots.waitingResponse': 'Esperando Respuesta',
'chatbots.sessions': 'sesiones',
'chatbots.completedLower': 'completados',
'chatbots.welcomeMessage': 'Mensaje inicial',
'chatbots.question': 'Pregunta',
'chatbots.options': 'Opciones',
'chatbots.more': 'más...',
'chatbots.default': 'Predeterminado',
'chatbots.noChatbots': 'No hay chatbots configurados',
'chatbots.createFirst': 'Crea tu primer chatbot para automatizar la atención',
'chatbots.editChatbot': 'Editar Chatbot',
'chatbots.configureAutoService': 'Configura la atención automatizada',
'chatbots.chatbotName': 'Nombre del Chatbot',
'chatbots.namePlaceholder': 'Ej: Asistente Virtual',
'chatbots.welcomeMessageLabel': 'Mensaje de Bienvenida',
'chatbots.welcomePlaceholder': 'Ej: ¡Hola! 👋 Bienvenido a nuestra empresa.',
'chatbots.questionLabel': 'Pregunta para el Cliente',
'chatbots.questionPlaceholder': 'Ej: Para dirigirte mejor, elige una opción:',
'chatbots.menuOptions': 'Opciones del Menú',
'chatbots.menuOptionsHelp': 'Agrega opciones que el cliente puede elegir. Cada opción dirige a un sector.',
'chatbots.addNewOption': 'Agregar nueva opción:',
'chatbots.optionLabelPlaceholder': 'Ej: Agendamiento',
'chatbots.selectSector': 'Sector...',
'chatbots.addOption': 'Agregar Opción',
'chatbots.defaultSectorLabel': 'Sector Predeterminado (si cliente no elige opción válida)',
'chatbots.noDefaultSector': 'Ninguno (dejar sin asignación)',
'chatbots.chatbotActive': 'Chatbot Activo',
'chatbots.triggerOnNew': 'Activar en nuevas conversaciones',
'chatbots.preview': 'Vista previa del Mensaje',
'chatbots.typeOptionNumber': 'Escribe el número de la opción:',
'chatbots.saveChanges': 'Guardar Cambios',
'chatbots.createChatbot': 'Crear Chatbot',

// Funnel
'funnel.title': 'Embudo de Ventas',
'funnel.subtitle': 'Visualiza y administra tus oportunidades',
'funnel.noConversations': 'No hay conversaciones en esta etapa',
'funnel.noMessages': 'Sin mensajes',
'funnel.high': 'Alta',
'funnel.medium': 'Media',
'funnel.low': 'Baja',
'funnel.conversationDetails': 'Detalles de la Conversación',  


  // Languages
  'language.pt-BR': '🇧🇷 Portugués',
  'language.en-US': '🇺 Inglés',
  'language.es-ES': '🇪🇸 Español',
  
  // Status
  'status.active': 'Activo',
  'status.inactive': 'Inactivo',
  'status.suspended': 'Suspendido',
  'status.cancelled': 'Cancelado',
  'status.approved': 'Aprobado',
  'status.pending': 'Pendiente',
  
  // Roles
  'role.master_admin': 'Master Admin',
  'role.admin': 'Administrador',
  'role.tenant_admin': 'Admin de la Empresa',
  'role.manager': 'Gerente',
  'role.attendant': 'Atendente',
  
  // Plans
  'plan.basic': 'Básico',
  'plan.professional': 'Profesional',
  'plan.enterprise': 'Empresarial',
  
  // Master Admin
  'tenants.title': 'Gestión de Empresas',
  'tenants.subtitle': 'Administra todas las empresas del sistema',
  'tenants.addNew': 'Agregar Nueva Empresa',
  'tenants.company': 'Empresa',
  'tenants.plan': 'Plan',
  'tenants.status': 'Estado',
  'tenants.users': 'Usuarios',
  'tenants.actions': 'Acciones',
  'tenants.defaultLanguage': 'Idioma Predeterminado',
  'tenants.defaultLanguageHelp': 'Idioma predeterminado para nuevos usuarios de esta empresa',
  
  // Settings
  'settings.title': 'Configuración',
  'settings.subtitle': 'Configura tu cuenta y preferencias',
};